export const pharmacyGoogleAuthActions = {
  GOOGLE_LOGIN: {
    REQUEST: 'googleAuth/googleLoginRequest',
    SUCCESS: 'googleAuth/googleLoginSuccess',
    FAILURE: 'googleAuth/googleLoginFailure'
  },

  GOOGLE_REGISTER: {
    REQUEST: 'googleAuth/googleRegisterRequest',
    SUCCESS: 'googleAuth/googleRegisterSuccess',
    FAILURE: 'googleAuth/googleRegisterFailure'
  }
};
